'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _itemTypeToComponent;
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactUltimatePagination = require('react-ultimate-pagination');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var withPreventDefault = function withPreventDefault(fn) {
  return function (event) {
    event.preventDefault();
    fn();
  };
};
var WrapperComponent = function WrapperComponent(_ref) {
  var children = _ref.children;
  return _react2.default.createElement('ul', {
    className: 'pagination'
  }, children);
};
var Page = function Page(_ref2) {
  var value = _ref2.value,
    isActive = _ref2.isActive,
    onClick = _ref2.onClick;
  return _react2.default.createElement('li', {
    className: isActive ? 'active' : null
  }, _react2.default.createElement('a', {
    href: '#',
    onClick: withPreventDefault(onClick)
  }, value));
};
var Ellipsis = function Ellipsis(_ref3) {
  var onClick = _ref3.onClick;
  return _react2.default.createElement('li', null, _react2.default.createElement('a', {
    href: '#',
    onClick: withPreventDefault(onClick)
  }, '...'));
};
var FirstPageLink = function FirstPageLink(_ref4) {
  var isActive = _ref4.isActive,
    onClick = _ref4.onClick;
  return _react2.default.createElement('li', null, _react2.default.createElement('a', {
    href: '#',
    onClick: withPreventDefault(onClick)
  }, '\xAB'));
};
var PreviousPageLink = function PreviousPageLink(_ref5) {
  var isActive = _ref5.isActive,
    onClick = _ref5.onClick;
  return _react2.default.createElement('li', null, _react2.default.createElement('a', {
    href: '#',
    onClick: withPreventDefault(onClick)
  }, '\u2039'));
};
var NextPageLink = function NextPageLink(_ref6) {
  var isActive = _ref6.isActive,
    onClick = _ref6.onClick;
  return _react2.default.createElement('li', null, _react2.default.createElement('a', {
    href: '#',
    onClick: withPreventDefault(onClick)
  }, '\u203A'));
};
var LastPageLink = function LastPageLink(_ref7) {
  var isActive = _ref7.isActive,
    onClick = _ref7.onClick;
  return _react2.default.createElement('li', null, _react2.default.createElement('a', {
    href: '#',
    onClick: withPreventDefault(onClick)
  }, '\xBB'));
};
var itemTypeToComponent = (_itemTypeToComponent = {}, _defineProperty(_itemTypeToComponent, _reactUltimatePagination.ITEM_TYPES.PAGE, Page), _defineProperty(_itemTypeToComponent, _reactUltimatePagination.ITEM_TYPES.ELLIPSIS, Ellipsis), _defineProperty(_itemTypeToComponent, _reactUltimatePagination.ITEM_TYPES.FIRST_PAGE_LINK, FirstPageLink), _defineProperty(_itemTypeToComponent, _reactUltimatePagination.ITEM_TYPES.PREVIOUS_PAGE_LINK, PreviousPageLink), _defineProperty(_itemTypeToComponent, _reactUltimatePagination.ITEM_TYPES.NEXT_PAGE_LINK, NextPageLink), _defineProperty(_itemTypeToComponent, _reactUltimatePagination.ITEM_TYPES.LAST_PAGE_LINK, LastPageLink), _itemTypeToComponent);
var UltimatePaginationBootstrap3 = (0, _reactUltimatePagination.createUltimatePagination)({
  itemTypeToComponent: itemTypeToComponent,
  WrapperComponent: WrapperComponent
});
exports.default = UltimatePaginationBootstrap3;